var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 60,
    fill: "#C02D62"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 62.5,
    stroke: "#CF4476",
    strokeOpacity: 0.3,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 125C98.1371 125 125 98.1371 125 65C125 54.6732 122.391 44.9557 117.796 36.4707C107.247 27.2519 93.442 21.6665 78.332 21.6665C45.1949 21.6665 18.332 48.5294 18.332 81.6665C18.332 91.9933 20.9409 101.711 25.5356 110.196C36.0845 119.415 49.89 125 65 125Z",
    fill: "#CF4476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1654 37C75.6529 37.0029 73.1676 37.5206 70.8628 38.521C68.558 39.5215 66.4827 40.9835 64.7647 42.8169C62.2471 40.1299 58.9798 38.2618 55.3871 37.4551C51.7944 36.6485 48.0421 36.9405 44.6174 38.2932C41.1928 39.646 38.2538 41.997 36.1822 45.0411C34.1105 48.0852 33.0018 51.6818 33 55.364C33 73.6485 62.4915 91.5956 63.7721 92.3004C64.0808 92.4859 64.4343 92.5839 64.7945 92.5839C65.1547 92.5839 65.5081 92.4859 65.8169 92.3004C67.0379 91.5956 96.5294 73.6485 96.5294 55.364C96.5242 50.4952 94.5877 45.8273 91.1449 42.3845C87.7021 38.9417 83.0343 37.0053 78.1654 37ZM64.7647 88.2603C59.6327 84.9846 36.9706 69.6779 36.9706 55.364C36.9731 52.3066 37.9492 49.3294 39.7573 46.8639C41.5654 44.3985 44.1116 42.5728 47.0269 41.6515C49.9422 40.7303 53.0752 40.7613 55.9717 41.74C58.8682 42.7188 61.3778 44.5945 63.1368 47.0952C63.32 47.3553 63.5631 47.5676 63.8456 47.7141C64.128 47.8606 64.4415 47.9371 64.7597 47.9371C65.0779 47.9371 65.3915 47.8606 65.6739 47.7141C65.9564 47.5676 66.1995 47.3553 66.3827 47.0952C68.1402 44.5902 70.6504 42.7104 73.5488 41.7289C76.4472 40.7474 79.583 40.7152 82.501 41.637C85.4189 42.5587 87.9672 44.3865 89.7758 46.8549C91.5844 49.3233 92.5593 52.3039 92.5588 55.364C92.5588 69.668 69.8967 84.9746 64.7647 88.2603Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLogo);
export default __webpack_public_path__ + "static/media/heartLogo.658b61d752e5f77fda2c97941295c7ef.svg";
export { ForwardRef as ReactComponent };